import { __assign, __rest } from "tslib";
import React, { useRef } from 'react';
import useDuperbrowseLink from '../hooks/useDuperbrowseLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import getBiDataForDeviationLink from './getBiDataForDeviationLink';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
var DeviationLink = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick, children = _a.children, extraBiData = _a.extraBiData, disableScrollRestoration = _a.disableScrollRestoration, _b = _a.canLinkToStash, canLinkToStash = _b === void 0 ? false : _b, restProps = __rest(_a, ["deviation", "onClick", "children", "extraBiData", "disableScrollRestoration", "canLinkToStash"]);
    var ref = useRef();
    var onDuperbrowseClick = useDuperbrowseLink(getDeviationEntityId(deviation), ref, onClick, disableScrollRestoration);
    if (!deviation.isPublished && !canLinkToStash) {
        return React.createElement("span", { className: restProps.className }, children);
    }
    return (React.createElement(BiLink, __assign({ "data-hook": BiDataHook.DEVIATION_LINK, href: getDeviationUrl(deviation), biData: __assign(__assign({}, getBiDataForDeviationLink(deviation)), extraBiData), onClick: onDuperbrowseClick, 
        // the undefined here is needed to keep react typings from going nuts
        innerRef: function (node) { return (ref.current = node || undefined); } }, restProps), children));
};
DeviationLink.displayName = 'DeviationLink';
export default DeviationLink;
//# sourceMappingURL=DeviationLink.js.map